import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const DataPickerArrow = (props) => (
  <Icon viewBox="0 0 8 13" {...props}>
    <g>
      <title>Data-picker-arrow</title>
      <path d="M7.954 6.248L.995 12.999 0 12.037l5.928-5.751L.014.957 1.008 0l5.911 5.325 1.035.923" fill="currentColor" fillRule="evenodd"
      />
    </g>
  </Icon>
);
/*eslint-enable */

export default DataPickerArrow;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/DataPickerArrow.js